import { OperationalCurrencyInterface } from "./OperationalCurrency";

export enum OPERATIONAL_COUNTRY_CURRENCY_SEPARATOR {
  POINT = "POINT",
  COMMA = "COMMA",
  SPACE = "SPACE",
  NONE = "NONE",
}

export const currencySeparatorValue = {
  [OPERATIONAL_COUNTRY_CURRENCY_SEPARATOR.POINT]: ".",
  [OPERATIONAL_COUNTRY_CURRENCY_SEPARATOR.COMMA]: ",",
  [OPERATIONAL_COUNTRY_CURRENCY_SEPARATOR.SPACE]: " ",
  [OPERATIONAL_COUNTRY_CURRENCY_SEPARATOR.NONE]: "",
};

export interface OperationalLanguageInterface {
  id: number;
  name: string;
  createdById: number;
  shortName: string;
  createdAt: string;
  deleted: boolean;
  localName: string;
}
export interface OperationalCountryInterface {
  id: number;
  name: string;
  vat: number;
  shortName: string;
  currency: OperationalCurrencyInterface;
  currencySeparator: OPERATIONAL_COUNTRY_CURRENCY_SEPARATOR;
  language: OperationalLanguageInterface;
}
